import { endOfDay, formatISO, parseISO, startOfDay } from 'date-fns';

/** yyyy-MM-dd → start-of-day ISO-8601 with local timezone offset (e.g. +08:00). */
export function toStartOfDayISO(yyyyMmDd: string): string {
  return formatISO(startOfDay(parseISO(yyyyMmDd)));
}

/** yyyy-MM-dd → end-of-day ISO-8601 with local timezone offset. */
export function toEndOfDayISO(yyyyMmDd: string): string {
  return formatISO(endOfDay(parseISO(yyyyMmDd)));
}

export const getChainStorePayPlatformUrl = (
  paymentId: string | null | undefined,
) => {
  if (!paymentId) return null;
  const vite_base_url = import.meta.env.VITE_BASE_URL;

  return `${vite_base_url}/invoices/${paymentId}/edit`;
};
